import { z } from "zod";
export const EventDataSourceImported = z.object({
    type: z.literal("DataSourceImported"),
    workspaceId: z.string(),
    designSystemId: z.string(),
});
